import React, {useState} from 'react';
import {Modal} from 'antd';
import "../../assets/css/Dentobook.css";
import "../../assets/css/PatientPhotos.css";
import {FormattedMessage} from "react-intl";
import {CloseOutlined} from '@ant-design/icons';
import {InvoiceResponse} from "../../api-client";
import logger from "../../utils/logger";

interface PatientInvoiceGenerateModalProps {
    invoice: InvoiceResponse | undefined;
    convertProforma: Function;
    isModalOpen: boolean;
    setIsModalOpen: Function;
}

const PatientInvoiceGenerateModal = ({
                                         invoice, convertProforma, isModalOpen, setIsModalOpen
                                     }: PatientInvoiceGenerateModalProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const handleCancel = () => {
        setIsModalOpen(false);
    }

    const handleOk = async () => {
        if (!invoice) {
            logger.log('invoice is undefined');

            return;
        }

        setLoading(true);

        await convertProforma(invoice);

        setLoading(false);
        setIsModalOpen(false);
    }

    return (
        <Modal
            transitionName=""
            className={'dentobook-modal dentobook-small-modal'}
            okButtonProps={{
                className: "modal-btn"
            }}
            cancelButtonProps={{
                className: "modal-btn"
            }}
            confirmLoading={loading}
            width={600}
            okText={<FormattedMessage id="generate_btn"/>}
            cancelText={<FormattedMessage id="cancel"/>}
            closeIcon={<CloseOutlined className={'icon-24px'} onClick={handleCancel}/>}
            open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                <h3 className="font-24 font-weight-500 text-center text-align-center" style={{width: 430}}>
                    <FormattedMessage id="invoice_generate_confirm"/>
                </h3>
            </div>
        </Modal>
    );
};

export default PatientInvoiceGenerateModal;